import { RouteRecordRaw } from "vue-router";
import { t } from "@/core/i18n";

export const route: RouteRecordRaw = {
  path: "/dashboard",
  name: "dashboard",
  redirect: { name: "DashboardOverview" },
  children: [
    {
      path: "overview",
      name: "DashboardOverview",
      component: () => import("./screens/Overview.vue"),
      meta: {
        breadcrumb: [{ title: t("dashboard"), routeName: "DashboardOverview" }],
      },
    },
    {
      // Intentionally not in the sidebar: reachable by URL only until the mobile
      // apps report to GA (Bedayat-ly/Enjaz-Mobile-V2#1).
      path: "app-usage",
      name: "DashboardAppUsage",
      component: () => import("./screens/AppUsage.vue"),
      meta: {
        breadcrumb: [
          { title: t("dashboard"), routeName: "dashboard" },
          { title: t("app-usage"), routeName: "DashboardAppUsage" },
        ],
      },
    },
  ],
};
